var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flats-find-num"},[(_vm.globalLang != 'kz/')?_c('div',{staticClass:"msg"},[_vm._v("Найдено "+_vm._s(_vm.filterFlatsDataBase.filter_items_count)+" "+_vm._s(_vm.correctWord))]):_vm._e(),(_vm.globalLang == 'kz/')?_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.filterFlatsDataBase.filter_items_count)+" пәтер табылды")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }